import { render, staticRenderFns } from "./BlockContentCarousel.vue?vue&type=template&id=56b7c026&"
import script from "./BlockContentCarousel.vue?vue&type=script&lang=js&"
export * from "./BlockContentCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BlockContentCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports